// extracted by mini-css-extract-plugin
export default {"readOnly":"styles__readOnly___cOa89"};